import React from 'react'
import {ExpenseDashboard} from '@/components/expense-dashboard/ExpenseDashboard'

const BuilderExpenseDashboard: React.FC<{userEmail: string}> = ({userEmail}) => (
    <ExpenseDashboard userEmail={userEmail} data-testid={'BuilderExpenseDashboard'} />
)

export const ExpenseDashboardDefinition = {
    component: BuilderExpenseDashboard,
    name: 'Expense Dashboard',
    noWrap: true,
    inputs: [
        {
            name: 'userEmail',
            type: 'string',
            required: true
        }
    ]
}
